'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/router/ntp/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "NTP" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/router/ntp/StaticView#model
   * @type {actions/router/ntp/EditNtp}
   */

  template: twig({data: tpl}),
});
